import { createSignal } from 'solid-js';
import { Profile } from '@dtvgo/backend-service';

export const [profile, setProfile] = createSignal<Profile | undefined>();

export const profileToken = () => profile()?.profileToken;
